import { Box, Typography } from '@mui/material';
import React from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { NACHWEIS_POSITION_STATUS, PLATZHALTER_TEXT, PROJEKTDURCHFUERUNG } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

import { concat, get } from 'lodash';
import Schema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import {
	formStrucPruefAssistenz,
	getNachweisAusgabenPath,
	getNachweisPruefAssistenzPaths,
	shouldValidatePruefAssistenz,
} from '../../content/helpers/projekteausgabenNachweisHelper';
const MA_P = Schema.attributes;
const NP_P = NachweisPositionSchema.attributes;
const EPZ_PROJEKTAUSGABEN_GESAMT_PATH = 'epzProjektausgabenGesamt';
const ROW_LABEL_WIDTH = '26rem';
const ROW_INPUT_WIDTH = '22rem';
const ROW_GAP = 2;

export const ProjektausgabenMAEpz = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const angefallenPath = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const anfallendePath = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	const angefalleneAusgaben = Number(get(application, angefallenPath, 0)) || 0;
	const anfallendeAusgaben = Number(get(application, anfallendePath, 0)) || 0;
	const gesamtAusgaben = angefalleneAusgaben + anfallendeAusgaben;
	const pruefAssistenzPathsAngefallen = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const pruefAssistenzPathsAnfallende = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	const anzahlMonate =
		(
			get(
				application,
				MA_P.Foerderantrag.schema.attributes.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektdurchfuehrung.path,
				'',
			) === PROJEKTDURCHFUERUNG.inland
		) ?
			'drei'
		:	'sechs';

	return (
		<>
			<ApplicationHeading title={'Projektausgaben'} description={PLATZHALTER_TEXT} />
			<Typography sx={{ fontWeight: 600, mb: 2 }}>
				Bitte geben Sie hier die Höhe der für den Zuwendungszweck bestimmten Ausgaben an, die im betrachteten Haushaltsjahr
			</Typography>
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
				<PruefAssistenz
					statusPath={pruefAssistenzPathsAngefallen.statusPath}
					hinweisPath={pruefAssistenzPathsAngefallen.hinweisPath}
					ueberarbeitetAmPath={pruefAssistenzPathsAngefallen.ueberarbeitetAmPath}
					erledigtPath={pruefAssistenzPathsAngefallen.erledigtPath}
					formStruc={formStrucPruefAssistenz(pruefAssistenzPathsAngefallen.erledigtPath)}
					sx={{ width: { xs: '100%', md: `calc(${ROW_LABEL_WIDTH} + ${ROW_INPUT_WIDTH} + 1rem)` } }}
				/>
				<Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexWrap: 'wrap', gap: ROW_GAP }}>
					<Typography sx={{ width: { xs: '100%', md: ROW_LABEL_WIDTH } }}>bis jetzt angefallen sind (kumuliert)</Typography>
					<Box sx={{ width: { xs: '100%', md: ROW_INPUT_WIDTH } }}>
						<CreateForm
							formValues={application}
							formStruc={formStrucAngefallen(application)}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Box>
				</Box>

				<PruefAssistenz
					statusPath={pruefAssistenzPathsAnfallende.statusPath}
					hinweisPath={pruefAssistenzPathsAnfallende.hinweisPath}
					ueberarbeitetAmPath={pruefAssistenzPathsAnfallende.ueberarbeitetAmPath}
					erledigtPath={pruefAssistenzPathsAnfallende.erledigtPath}
					formStruc={formStrucPruefAssistenz(pruefAssistenzPathsAnfallende.erledigtPath)}
					sx={{ width: { xs: '100%', md: `calc(${ROW_LABEL_WIDTH} + ${ROW_INPUT_WIDTH} + 1rem)` } }}
				/>
				<Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexWrap: 'wrap', gap: ROW_GAP }}>
					<Typography sx={{ width: { xs: '100%', md: ROW_LABEL_WIDTH } }}>und in den nächsten {anzahlMonate} Monaten anfallen werden</Typography>
					<Box sx={{ width: { xs: '100%', md: ROW_INPUT_WIDTH } }}>
						<CreateForm
							formValues={application}
							formStruc={formStrucAnfallende(application)}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Box>
				</Box>

				<Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexWrap: 'wrap', gap: ROW_GAP }}>
					<Typography sx={{ width: { xs: '100%', md: ROW_LABEL_WIDTH }, fontWeight: 600 }}>Gesamt</Typography>
					<Box sx={{ width: { xs: '100%', md: ROW_INPUT_WIDTH } }}>
						<CreateForm
							formValues={{ [EPZ_PROJEKTAUSGABEN_GESAMT_PATH]: gesamtAusgaben }}
							formStruc={formStrucGesamt()}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={true}
						/>
					</Box>
				</Box>
			</Box>
		</>
	);
};

const getPruefAssistenzPathsByStatus = (application: any, status: string) => {
	return getNachweisPruefAssistenzPaths(application, (eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
};

const getNachweisAusgabenPathByStatus = (application: any, status: string) => {
	return getNachweisAusgabenPath(application, (eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
};

const formStrucAngefallen = (application: any) => {
	const path = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					path,
					label: '',
					format: 'currency',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};
const formStrucAnfallende = (application: any) => {
	const path = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					path,
					label: '',
					format: 'currency',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucGesamt = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ path: EPZ_PROJEKTAUSGABEN_GESAMT_PATH, type: 'decimal', label: '', disabled: true, format: 'currency' }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

export const getFormstrucProjektausgabenMAEpz = (application: any) => {
	let struc: FormStrucItem[] = [];
	const pruefAssistenzPathsAngefallen = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const pruefAssistenzPathsAnfallende = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	const shouldValidateAngefallen = shouldValidatePruefAssistenz(application, pruefAssistenzPathsAngefallen);
	const shouldValidateAnfallende = shouldValidatePruefAssistenz(application, pruefAssistenzPathsAnfallende);

	if (shouldValidateAngefallen) {
		struc = concat(struc, formStrucPruefAssistenz(pruefAssistenzPathsAngefallen.erledigtPath));
	}

	if (shouldValidateAnfallende) {
		struc = concat(struc, formStrucPruefAssistenz(pruefAssistenzPathsAnfallende.erledigtPath));
	}
	struc = concat(struc, formStrucAngefallen(application), formStrucAnfallende(application));

	return struc;
};
